import { render } from "./anexos.vue?vue&type=template&id=0e6f4424&scoped=true"
import script from "./anexos.vue?vue&type=script&lang=js"
export * from "./anexos.vue?vue&type=script&lang=js"

import "./anexos.vue?vue&type=style&index=0&id=0e6f4424&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e6f4424"]])

export default __exports__